export default __webpack_public_path__ + "98c3fcaf0f183385641f429c9dc03afd.jpg";